import React from 'react'

const ShimmerCard = () => {
  return (
    <div className='rounded-lg border-2 p-4 shadow-lg bg-gray-200'>
    
    <div className='relative w-[240px] h-[240px] bg-bgDark bg-opacity-80 rounded-lg overflow-hidden  pointer-events-auto'>
        </div>  
</div>
  )
}

export default ShimmerCard